/* eslint-disable max-len */
import React from "react"
import styled from "styled-components"

import BaseSvgIcon from "./Base"
import {greys} from "../../global/colors"

const Text = styled.text`
  cursor: default;
`

const I = ({color = greys.mediumDark, ...props}) => (
  <BaseSvgIcon color={color} {...props} viewBox="0 0 16 16">
    <circle fill="none" stroke={color} cx="8" cy="8" r="7" />
    <Text
      id="i"
      fontFamily="WorkSansSemibold, WorkSansMedium"
      fontSize="11"
      fontWeight="500"
      letterSpacing="0.1721738"
      fill={color}>
      <tspan x="7" y="12">i</tspan>
    </Text>
  </BaseSvgIcon>
)

export default I
